<template>
  <div>
    <div class="flex flex-col items-center justify-center gap-4 py-8">
      <picture>
        <source
          type="image/webp"
          srcset="@/assets/images/filled-search-icon.webp"
        />
        <img
          width="48"
          height="48"
          src="@/assets/images/filled-search-icon.png"
          role="presentation"
          alt=""
        />
      </picture>
      <p class="text-text-neutral-primary whitespace-pre-wrap text-center">
        {{ t('search.filters.noFilteredOffers') }}
      </p>
    </div>
    <SearchTicketsList
      :start-idx="startIdx"
      :dict="dict"
      :offers-list="offers"
      :is-recommended-sorting-mode="isRecommendedSortingMode"
      :use-ranking-offer-labels="useRankingOfferLabels"
      :ranking="ranking"
      :offer-id="offerId"
      :search-query="searchQuery"
      :is-multi-trip-search="isMultiTripSearch"
      @onOfferSelect="handleOfferSelect"
      @onScrollToOfferEnd="emit('onScrollToOfferEnd')"
    />
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import type { Dict } from '@aviata/platform-types';
  import type { flightEntity } from 'freedom-shared';

  import type { OfferRankingEntry } from '@/features/search-tickets';

  import SearchTicketsList from './SearchTicketsList.vue';

  defineProps<{
    startIdx: number;
    dict: Dict.Entity;
    offers: flightEntity.types.MappedOffer[];
    isRecommendedSortingMode: boolean;
    useRankingOfferLabels?: boolean;
    ranking?: OfferRankingEntry[];
    offerId?: string;
    searchQuery: string;
    isMultiTripSearch?: boolean;
  }>();

  const emit = defineEmits<{
    onOfferSelect: [offer: flightEntity.types.MappedOffer, idx: number];
    onScrollToOfferEnd: [];
  }>();

  const { t } = useI18n();

  const handleOfferSelect = (
    offer: flightEntity.types.MappedOffer,
    index: number,
  ) => {
    emit('onOfferSelect', offer, index);
  };
</script>
